import React, { FC } from "react";
import { NavbarWidget } from "shared/components/__FOX__/NAV/src";
import { useTheme } from "styled-components";
import {useGetFilteredTabs} from "../components/navigationSystem/useGetFilteredTabs";

const SectionSuperPuper: FC = () => {
    const theme = useTheme();
    const items = useGetFilteredTabs()

    return (
            <NavbarWidget.Links
                key="links-widget"
                theming={theme.navigationBar.links}
            items={items}
        />
    );
};

export default SectionSuperPuper;
import React, { FC } from "react";
import { NavbarWidget } from "shared/components/__FOX__/NAV/src";
import { useTheme } from "styled-components";
import {useGetFilteredTabs} from "../components/navigationSystem/useGetFilteredTabs";

const SectionSuperPuper: FC = () => {
    const theme = useTheme();
    const items = useGetFilteredTabs()

    return (
            <NavbarWidget.Links
                key="links-widget"
                theming={theme.navigationBar.links}
            items={items}
        />
    );
};

export default SectionSuperPuper;
